import { useMutation, useQuery, UseQueryResult } from 'react-query';
import { PersonAPI } from '@frontend/api-person';
import { initiateEligibilityReportWriteback } from './api';
import { EligibilityReportWritebackParams } from './types';

export const usePersonImage = (personId: string, enabled?: boolean): UseQueryResult<string, any> => {
  return useQuery([personId, 'photo'], () => PersonAPI.getPersonImage(personId), {
    staleTime: 5 * 60 * 1000, // Adding stale time as 5 mins will be invalidating query during writebacks
    enabled: !!enabled && !!personId,
    retry: false,
    refetchOnWindowFocus: false,
    cacheTime: 15 * 60 * 1000, // Caching PMS data for 15 mins will be invalidating query during writebacks,
    onError: () => console.error('Error fetching person image'),
  });
};

export const useInitiateEligibilityReportWriteback = (locationId: string) => {
  return useMutation({
    mutationFn: ({ eligibilityReportWritebackRequest, personPMSId, sourceId }: EligibilityReportWritebackParams) =>
      initiateEligibilityReportWriteback(eligibilityReportWritebackRequest, sourceId, personPMSId),
    retry: false,
    mutationKey: [locationId, 'eligibility-report-writeback'],
  });
};
